/* unplugin-vue-components disabled */import script from "./commonTit.vue?vue&type=script&lang=ts&setup=true"
export * from "./commonTit.vue?vue&type=script&lang=ts&setup=true"

import "./commonTit.vue?vue&type=style&index=0&id=0ba34eb2&scoped=true&lang=less"

import exportComponent from "E:\\projects\\front\\ysdp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ba34eb2"]])

export default __exports__